import React from 'react';

import API from "../../../components/api";
import {withRouter} from "../../../layouts/MainLayout/MainLayout";


class AdminRedirectPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    componentDidMount() {
        API.adminMe()
            .then(data => {
                this.props.navigate('/admin/panel/services/');
            })
            .catch((error) => {
                this.props.navigate('/admin/login/');
            })
    }

    render() {
        return <div/>
    }
}


export default withRouter(AdminRedirectPage);
